import { css } from "@compiled/react";

import AccountCreation, { Social } from "@/components/signup/account-creation";
import { SocialProvider } from "@/components/signup/utils";
import { wacToken } from "@/libraries/design/foundations";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export type SignUpFormTextColor = "default" | "light";

export type UniformSignUpProps = {
    socialProviders?: SocialProvider[];
    textColor?: SignUpFormTextColor;
};

export const transformProviders = (providerList: string[]) => {
    return providerList.reduce(
        (previous, key) => ({ ...previous, [key.toLowerCase()]: key }),
        {}
    );
};

const textColorCss = css({
    "&.light-text": {
        "color": wacToken("color.neutral.light0"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- this is a specific use case for the sign up form
        "#account_creation_email_help_text": {
            color: wacToken("color.neutral.light0")
        }
    }
});

const lightTextColorCss = css({
    color: wacToken("color.neutral.light0")
});

const UniformSignUpForm = ({
    socialProviders,
    textColor = "default"
}: UniformSignUpProps) => {
    const inheritColorHelpText = checkFeatureFlagGate(
        featureFlags.signupAccountCreationInheritTextColor
    );
    return (
        <div
            css={[
                !inheritColorHelpText && textColorCss,
                inheritColorHelpText &&
                    textColor === "light" &&
                    lightTextColorCss
            ]}
            className={textColor === "light" ? "light-text" : "dark-text"}
        >
            <AccountCreation
                Login={null}
                Social={
                    socialProviders?.length ? (
                        <Social
                            providers={transformProviders(socialProviders)}
                        />
                    ) : undefined
                }
            />
        </div>
    );
};

export default UniformSignUpForm;
